export enum EWsErrorMessage {
  SessionExpired = 'sessionExpired',
  InvalidSession = 'invalidSession',
  ValidationError = 'validationError',
}

export enum EWsCodeError {
  MessageHasLinkToAnotherService = 'messageHasLinkToAnotherService',
}
